import { z } from "zod";

export const OfferKpiType = {
  ALL: "ALL",
  OPEN: "OPEN",
  GTDELTA: "GTDELTA",
  LTDELTA: "LTDELTA",
  EXPIRING: "EXPIRING",
  NOTOPEN: "NOTOPEN",
  ACCEPTED: "ACCEPTED",
  REFUSED: "REFUSED",
  LOST: "LOST",
};

export const OfferStatus = {
  OPEN: "OPEN",
  ACCEPTED: "ACCEPTED",
  EXPIRED: "EXPIRED",
  LOST: "LOST",
  REFUSED: "REFUSED",
  NOTOPEN: "NOTOPEN",
  ALL: "ALL",
};

export interface OffersQueryParams {
  expiryDateFrom?: string;
  expiryDateTo?: string;
  offerDateFrom?: string;
  offerDateTo?: string;
  offerId?: string;
  pageNumber?: number;
  pageSize?: number;
  deltagt?: number;
  deltalt?: number;
  sortByAsc?: string;
  sortByDesc?: string;
  status?: string;
  activeDateRangeId?: string;
  activeKpiType?: string;
  customFilters?: string;
}

const offerSchema = z.object({
  id: z.string(),
  ean: z.string(),
  modelCode: z.string(),
  productTitle: z.string(),
  brand: z.string(),
  color: z.string(),
  size: z.string(),
  catalogImgUrl: z.string(),
  stockQuantity: z.number(),
  offerPrice: z.number(),
  sellingPrice: z.number(),
  delta: z.number(),
  deltaPercentage: z.number(),
  offerDate: z.string().datetime(),
  expiryDate: z.string().datetime(),
  status: z.enum([
    "OPEN",
    "ACCEPTED",
    "EXPIRED",
    "LOST",
    "REFUSED",
    "NOTOPEN",
    "ALL",
  ]),
});

export type Offers = z.infer<typeof offerSchema>;

export const offersDateSchema = z.object({ from: z.date(), to: z.date() });

export const offersFiltersSchema = z.object({
  offerId: z.string().optional(),
  offerDate: offersDateSchema.optional(),
  expiryDate: offersDateSchema.optional(),
});

export type OffersFiltersForm = z.infer<typeof offersFiltersSchema>;
